function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignInGirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,448.53c134.56-.61,285.5-.61,420.06,0-134.56.62-285.5.61-420.06,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2",
    transform: "matrix(1, 0, 0, 1, -26.69903, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.18,58.3H207.86a17.59,17.59,0,0,0-17.43,17.76V430.77a17.61,17.61,0,0,0,17.43,17.76H380.18a17.62,17.62,0,0,0,17.45-17.76V76.06A17.61,17.61,0,0,0,380.18,58.3Zm6.54,361.5c0,9.34-7,16.89-15.61,16.89H217c-8.65,0-15.64-7.55-15.64-16.89V89.5c0-19,7-20,15.64-20h30.88c1.79,0,3.26,2,3.26,4.57v1.09c0,5.92,3.24,5.94,7.22,5.94h71.41c4,0,7.23,0,7.23-5.94V74.12c0-2.53,1.45-4.57,3.28-4.57h30.87c8.62,0,15.61,2.53,15.61,20Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.73,89.5V419.8c0,9.34-7,16.89-15.61,16.89H217c-8.65,0-15.64-7.55-15.64-16.89V89.5c0-19,7-20,15.64-20h30.88c1.79,0,3.26,2,3.26,4.57v1.09c0,5.92,3.24,5.94,7.22,5.94h71.41c4,0,7.23,0,7.23-5.94V74.12c0-2.53,1.45-4.57,3.28-4.57h30.87C379.74,69.55,386.73,72.08,386.73,89.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.73,89.51v30H201.33v-30c0-19,7-20,15.64-20h30.88c1.79,0,3.26,2,3.26,4.57v1.09c0,5.92,3.24,5.94,7.22,5.94h71.41c4,0,7.23,0,7.23-5.94V74.13c0-2.53,1.45-4.57,3.28-4.57h30.87C379.74,69.56,386.73,72.09,386.73,89.51Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.77,73.47H284.29a1.2,1.2,0,0,1-1.2-1.21h0a1.2,1.2,0,0,1,1.2-1.2h19.48a1.2,1.2,0,0,1,1.2,1.2h0A1.21,1.21,0,0,1,303.77,73.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.41,
    y: 97.8,
    width: 16.09,
    height: 10.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.5,97.8c-.65.62-1.31,1.22-2,1.83s-1.32,1.2-2,1.79l-2.08,1.84-.07.06-1.85,1.61-.09.07-.09-.07-1.85-1.62-.07,0-2.09-1.84-2-1.79c-.65-.61-1.32-1.21-2-1.83l2.06,1.64c.68.56,1.36,1.11,2,1.68s1.5,1.26,2.26,1.9h0l1.69,1.44c.56-.48,1.12-1,1.69-1.44h0l2.26-1.9,2-1.67C228.13,98.89,228.81,98.34,229.5,97.8Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.79,103.25l0,0-.25.21c-.41.34-.82.67-1.24,1s-1,.76-1.56,1.13-1.06.73-1.61,1.08-1.09.69-1.66,1c.49-.43,1-.83,1.51-1.22s1-.76,1.56-1.13,1.07-.73,1.61-1.08.87-.55,1.32-.81l.32-.17Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.47,107.68c-.57-.31-1.12-.65-1.66-1s-1.08-.71-1.61-1.08-1-.74-1.57-1.13-.83-.64-1.23-1l-.25-.21s0,0,0,0,0,0,0,0l.32.18q.66.39,1.32.81c.54.35,1.07.71,1.6,1.08s1.05.74,1.56,1.13S229,107.25,229.47,107.68Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,97.8a3.46,3.46,0,1,1-3.46-3.45A3.46,3.46,0,0,1,233,97.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.64,98.49a.27.27,0,0,1-.28.27h-.05v.38a.26.26,0,0,1-.27.27.27.27,0,0,1-.27-.27v-.38h-1.56a.22.22,0,0,1-.17-.06.27.27,0,0,1,0-.38L229.83,96h0v0h0s0,0,0,0h0s0,0,0,0h.21l0,0,0,0h0v0l0,0s0,0,0,0a0,0,0,0,0,0,0s0,0,0,0v0s0,0,0,0v2h.05A.27.27,0,0,1,230.64,98.49Zm-.87-1.5-1,1.23h1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.51,76.68l-.3.3-.17.17a4.07,4.07,0,0,0-5.75,0,1.29,1.29,0,0,1-.16-.17l-.3-.29h0l0,0,.38-.34a4.72,4.72,0,0,1,2-.94c.19,0,.39,0,.58-.08h.5l.4,0a4.33,4.33,0,0,1,1.06.26,4.69,4.69,0,0,1,.72.33,4.63,4.63,0,0,1,.68.48l.32.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.23,78.09c-.15-.16-.31-.31-.47-.47a3.3,3.3,0,0,1,1.92-1,3.37,3.37,0,0,1,2.89,1l-.48.47a2.74,2.74,0,0,0-3.86,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.62,78.56l-.47.47a1.39,1.39,0,0,0-2,0l-.47-.47A2,2,0,0,1,240.62,78.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.59,79.45a.43.43,0,1,1-.85,0,.43.43,0,0,1,.85,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.41,77.58a1.23,1.23,0,1,1,1.23,1.23A1.23,1.23,0,0,1,213.41,77.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.28,77.58a1.23,1.23,0,1,1,1.23,1.23A1.23,1.23,0,0,1,217.28,77.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.15,77.58a1.23,1.23,0,1,1,1.23,1.23A1.23,1.23,0,0,1,221.15,77.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,77.58a1.23,1.23,0,1,1,1.23,1.23A1.23,1.23,0,0,1,225,77.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.89,77.58a1.23,1.23,0,1,1,1.23,1.23A1.23,1.23,0,0,1,228.89,77.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.82,80.27h-10V75.63h10Zm-9.49-.51h9V76.14h-9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.65,
    y: 76.42,
    width: 6.45,
    height: 3.06,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.83,
    y: 76.71,
    width: 0.89,
    height: 2.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.2,106.73l-1.26,1-2.33-3.08-.86-1.13a2,2,0,0,0,.49-.27,2.1,2.1,0,0,0,.65-.84l.91,1.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.72,99.47a3.48,3.48,0,1,0-.64,4.82,3.37,3.37,0,0,0,.72-.74A3.44,3.44,0,0,0,358.72,99.47Zm-1.48,3.73a2,2,0,0,1-.49.27,2,2,0,1,1,1.14-1.11A2.1,2.1,0,0,1,357.24,103.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.95,
    y: 98.33,
    width: 9.14,
    height: 9.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.02,
    y: 100.03,
    width: 1,
    height: 5.75,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.02,
    y: 100.03,
    width: 1,
    height: 5.75,
    transform: "translate(236.62 442.43) rotate(-90)",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.81,98.92a.79.79,0,1,1-.79-.79A.79.79,0,0,1,372.81,98.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.81,103a.79.79,0,1,1-.79-.79A.79.79,0,0,1,372.81,103Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.81,107.12a.79.79,0,1,1-.79-.79A.79.79,0,0,1,372.81,107.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.33,
    y: 319.89,
    width: 185.4,
    height: 28.63,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.33,
    y: 319.89,
    width: 185.4,
    height: 28.63,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.33,
    y: 262.63,
    width: 185.4,
    height: 28.63,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.33,
    y: 262.63,
    width: 185.4,
    height: 28.63,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.33,
    y: 119.47,
    width: 185.4,
    height: 28.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,139.32a6.22,6.22,0,0,1-1.87.78,6.49,6.49,0,1,1,1.87-.78Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,133a2,2,0,1,1-2-2A2,2,0,0,1,230,133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,138.5v.82a6.22,6.22,0,0,1-1.87.78,6.51,6.51,0,0,1-5-.78v-.82a3.42,3.42,0,0,1,6.84,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.88 138.09 260.28 138.09 263.78 133.79 260.28 129.49 268.88 129.49 272.38 133.79 268.88 138.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.78 129.49 248.17 132.32 251.3 132.77 249.04 134.98 249.57 138.09 246.78 136.62 243.98 138.09 244.52 134.98 242.25 132.77 245.38 132.32 246.78 129.49",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.55,
    y: 132.04,
    width: 50.74,
    height: 3.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.21,
    y: 132.04,
    width: 19.89,
    height: 3.5,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,168a6.22,6.22,0,0,1-1.87.78,6.49,6.49,0,1,1,1.87-.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,161.68a2,2,0,1,1-2-2A2,2,0,0,1,230,161.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,167.13V168a6.22,6.22,0,0,1-1.87.78,6.47,6.47,0,0,1-5-.78v-.82a3.42,3.42,0,0,1,6.84,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.88 166.72 260.28 166.72 263.78 162.42 260.28 158.12 268.88 158.12 272.38 162.42 268.88 166.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,167h-9.25l3.71-4.55-3.71-4.55H269l3.71,4.55Zm-8.2-.5h8l3.3-4.05-3.3-4h-8l3.31,4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.78 158.12 248.17 160.95 251.3 161.4 249.04 163.61 249.57 166.72 246.78 165.25 243.98 166.72 244.52 163.61 242.25 161.4 245.38 160.95 246.78 158.12",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.55,
    y: 160.67,
    width: 50.74,
    height: 3.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.21,
    y: 160.67,
    width: 19.89,
    height: 3.5,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.32,
    y: 176.73,
    width: 155.66,
    height: 28.64,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.32,
    y: 176.73,
    width: 155.66,
    height: 28.64,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.32,
    y: 189.3,
    width: 38.69,
    height: 3.5,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.93,
    y: 189.3,
    width: 19.89,
    height: 3.5,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,225.21a6.5,6.5,0,1,1,2.9-7.07A6.5,6.5,0,0,1,231.46,225.21Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,218.94a2,2,0,1,1-2-2A2,2,0,0,1,230,218.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,224.4v.81a6.47,6.47,0,0,1-6.84,0v-.81a3.42,3.42,0,1,1,6.84,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.88 223.98 260.28 223.98 263.78 219.68 260.28 215.38 268.88 215.38 272.38 219.68 268.88 223.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,224.23h-9.25l3.71-4.55-3.71-4.55H269l3.71,4.55Zm-8.2-.5h8l3.3-4-3.3-4.05h-8l3.31,4.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.78 215.38 248.17 218.21 251.3 218.67 249.04 220.87 249.57 223.98 246.78 222.51 243.98 223.98 244.52 220.87 242.25 218.67 245.38 218.21 246.78 215.38",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.55,
    y: 217.93,
    width: 50.74,
    height: 3.5,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.21,
    y: 217.93,
    width: 19.89,
    height: 3.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.33,
    y: 234,
    width: 185.4,
    height: 28.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,253.84a6.5,6.5,0,1,1,2.9-7.07A6.5,6.5,0,0,1,231.46,253.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,247.57a2,2,0,1,1-2-2A2,2,0,0,1,230,247.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,253v.81a6.47,6.47,0,0,1-6.84,0V253a3.42,3.42,0,0,1,6.84,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.88 252.61 260.28 252.61 263.78 248.31 260.28 244.01 268.88 244.01 272.38 248.31 268.88 252.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.78 244.01 248.17 246.84 251.3 247.3 249.04 249.5 249.57 252.61 246.78 251.14 243.98 252.61 244.52 249.5 242.25 247.3 245.38 246.84 246.78 244.01",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.55,
    y: 246.56,
    width: 50.74,
    height: 3.5,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.21,
    y: 246.56,
    width: 19.89,
    height: 3.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.33,
    y: 348.52,
    width: 185.4,
    height: 28.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,368.37a6.22,6.22,0,0,1-1.87.78,6.49,6.49,0,1,1,1.87-.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,362.09a2,2,0,1,1-2-2A2,2,0,0,1,230,362.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,367.55v.82a6.22,6.22,0,0,1-1.87.78,6.47,6.47,0,0,1-5-.79v-.81a3.42,3.42,0,0,1,6.84,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.88 367.14 260.28 367.14 263.78 362.84 260.28 358.54 268.88 358.54 272.38 362.84 268.88 367.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.78 358.54 248.17 361.37 251.3 361.82 249.04 364.02 249.57 367.14 246.78 365.67 243.98 367.14 244.52 364.02 242.25 361.82 245.38 361.37 246.78 358.54",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.55,
    y: 361.09,
    width: 50.74,
    height: 3.5,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.21,
    y: 361.09,
    width: 19.89,
    height: 3.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.73,405.78v14A17.15,17.15,0,0,1,379,434.41H209.11a17.14,17.14,0,0,1-7.78-14.61v-14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,425.63a6.5,6.5,0,1,1,2.9-7.07A6.5,6.5,0,0,1,231.46,425.63Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,419.36a2,2,0,1,1-2-2A2,2,0,0,1,230,419.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,424.81v.82a6.47,6.47,0,0,1-6.84,0v-.82a3.42,3.42,0,0,1,6.84,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.88 424.4 260.28 424.4 263.78 420.1 260.28 415.8 268.88 415.8 272.38 420.1 268.88 424.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.78 415.8 248.17 418.63 251.3 419.08 249.04 421.29 249.57 424.4 246.78 422.93 243.98 424.4 244.52 421.29 242.25 419.08 245.38 418.63 246.78 415.8",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.55,
    y: 418.35,
    width: 50.74,
    height: 3.5,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.21,
    y: 418.35,
    width: 19.89,
    height: 3.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.32,
    y: 275.19,
    width: 38.69,
    height: 3.5,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.93,
    y: 275.19,
    width: 19.89,
    height: 3.5,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.33,
    y: 291.26,
    width: 185.4,
    height: 28.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,311.11a6.5,6.5,0,1,1,2.9-7.08A6.48,6.48,0,0,1,231.46,311.11Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,304.83a2,2,0,1,1-2-2A2,2,0,0,1,230,304.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,310.29v.82a6.51,6.51,0,0,1-6.84,0v-.81a3.42,3.42,0,1,1,6.84,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.88 309.88 260.28 309.88 263.78 305.57 260.28 301.27 268.88 301.27 272.38 305.57 268.88 309.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.78 301.27 248.17 304.11 251.3 304.56 249.04 306.76 249.57 309.88 246.78 308.41 243.98 309.88 244.52 306.76 242.25 304.56 245.38 304.11 246.78 301.27",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.55,
    y: 303.83,
    width: 50.74,
    height: 3.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.21,
    y: 303.83,
    width: 19.89,
    height: 3.5,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.32,
    y: 332.46,
    width: 38.69,
    height: 3.5,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.93,
    y: 332.46,
    width: 19.89,
    height: 3.5,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,397a6.22,6.22,0,0,1-1.87.78,6.49,6.49,0,1,1,1.87-.78Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,390.73a2,2,0,1,1-2-2A2,2,0,0,1,230,390.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,396.18V397a6.22,6.22,0,0,1-1.87.78,6.47,6.47,0,0,1-5-.78v-.82a3.42,3.42,0,0,1,6.84,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.88 395.77 260.28 395.77 263.78 391.47 260.28 387.17 268.88 387.17 272.38 391.47 268.88 395.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,396h-9.25l3.71-4.55-3.71-4.55H269l3.71,4.55Zm-8.2-.5h8l3.3-4-3.3-4.05h-8l3.31,4.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.78 387.17 248.17 390 251.3 390.45 249.04 392.66 249.57 395.77 246.78 394.3 243.98 395.77 244.52 392.66 242.25 390.45 245.38 390 246.78 387.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9,396.23l-3.12-1.65-3.13,1.65.6-3.49-2.53-2.46,3.49-.51,1.57-3.17,1.56,3.17,3.5.51-2.53,2.46Zm-7.11-5.6,2,1.94-.47,2.74,2.47-1.29,2.46,1.29-.47-2.74,2-1.94-2.75-.4-1.23-2.5-1.23,2.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.55,
    y: 389.72,
    width: 50.74,
    height: 3.5,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.21,
    y: 389.72,
    width: 19.89,
    height: 3.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.45,
    y: 176.73,
    width: 29.76,
    height: 28.63,
    style: {
      fill: "#62CE71",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.33,185.85a5.21,5.21,0,1,0,5.21,5.21A5.2,5.2,0,0,0,312.33,185.85Zm-2.43,5.73a.52.52,0,0,1-.52-.52.52.52,0,1,1,1,0A.52.52,0,0,1,309.9,191.58Zm2.43,0a.53.53,0,0,1-.52-.52.52.52,0,0,1,.52-.52.52.52,0,0,1,.52.52A.52.52,0,0,1,312.33,191.58Zm2.44,0a.52.52,0,0,1-.52-.52.52.52,0,1,1,1,0A.52.52,0,0,1,314.77,191.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.21,
    y: 176.73,
    width: 29.76,
    height: 28.63,
    style: {
      fill: "#62CE71",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.43,
    y: 185.84,
    width: 0.61,
    height: 10.41,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.74,186.32c3.2-.85,6.41.85,9.62,0v7.09c-3.21.85-6.42-.85-9.62,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.97,
    y: 176.73,
    width: 29.76,
    height: 28.63,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.2 196.38 368.59 196.38 368.19 187.6 375.51 187.6 375.2 196.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.26,
    y: 186.97,
    width: 9.2,
    height: 0.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.5 187.28 373.02 187.28 373.02 186.2 370.69 186.2 370.69 187.28 370.21 187.28 370.21 185.72 373.5 185.72 373.5 187.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.61,
    y: 188.45,
    width: 0.48,
    height: 6.87,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.95,
    y: 188.45,
    width: 0.48,
    height: 6.88,
    transform: "translate(-7.76 15.77) rotate(-2.42)",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.08,
    y: 191.65,
    width: 6.88,
    height: 0.48,
    transform: "translate(165.75 556.81) rotate(-87.54)",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.45,
    y: 262.63,
    width: 29.76,
    height: 28.63,
    style: {
      fill: "#62CE71",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.33,271.74a5.21,5.21,0,1,0,5.21,5.21A5.2,5.2,0,0,0,312.33,271.74Zm-2.43,5.73a.52.52,0,0,1-.52-.52.52.52,0,1,1,1,0A.52.52,0,0,1,309.9,277.47Zm2.43,0a.53.53,0,0,1-.52-.52.52.52,0,0,1,.52-.52.52.52,0,0,1,.52.52A.52.52,0,0,1,312.33,277.47Zm2.44,0a.52.52,0,0,1-.52-.52.52.52,0,1,1,1,0A.52.52,0,0,1,314.77,277.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.21,
    y: 262.63,
    width: 29.76,
    height: 28.63,
    style: {
      fill: "#62CE71",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.43,
    y: 271.74,
    width: 0.61,
    height: 10.41,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.74,272.22c3.2-.86,6.41.85,9.62,0v7.08c-3.21.85-6.42-.85-9.62,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.97,
    y: 262.63,
    width: 29.76,
    height: 28.63,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.2 282.28 368.59 282.28 368.19 273.5 375.51 273.5 375.2 282.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.26,
    y: 272.86,
    width: 9.2,
    height: 0.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.5 273.18 373.02 273.18 373.02 272.09 370.69 272.09 370.69 273.18 370.21 273.18 370.21 271.61 373.5 271.61 373.5 273.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.61,
    y: 274.34,
    width: 0.48,
    height: 6.87,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.95,
    y: 274.34,
    width: 0.48,
    height: 6.88,
    transform: "translate(-11.38 15.85) rotate(-2.42)",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.08,
    y: 277.54,
    width: 6.88,
    height: 0.48,
    transform: "translate(80.01 639.07) rotate(-87.55)",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.45,
    y: 319.89,
    width: 29.76,
    height: 28.63,
    style: {
      fill: "#62CE71",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.33,329a5.21,5.21,0,1,0,5.21,5.21A5.2,5.2,0,0,0,312.33,329Zm-2.43,5.73a.52.52,0,0,1-.52-.52.52.52,0,1,1,1,0A.52.52,0,0,1,309.9,334.73Zm2.43,0a.53.53,0,0,1-.52-.52.52.52,0,0,1,.52-.52.52.52,0,0,1,.52.52A.52.52,0,0,1,312.33,334.73Zm2.44,0a.52.52,0,0,1-.52-.52.52.52,0,1,1,1,0A.52.52,0,0,1,314.77,334.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.21,
    y: 319.89,
    width: 29.76,
    height: 28.63,
    style: {
      fill: "#62CE71",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.43,
    y: 329,
    width: 0.61,
    height: 10.41,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.74,329.48c3.2-.85,6.41.85,9.62,0v7.08c-3.21.85-6.42-.85-9.62,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.97,
    y: 319.89,
    width: 29.76,
    height: 28.63,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.2 339.54 368.59 339.54 368.19 330.76 375.51 330.76 375.2 339.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.26,
    y: 330.12,
    width: 9.2,
    height: 0.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.5 330.44 373.02 330.44 373.02 329.35 370.69 329.35 370.69 330.44 370.21 330.44 370.21 328.87 373.5 328.87 373.5 330.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.61,
    y: 331.61,
    width: 0.48,
    height: 6.87,
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.95,
    y: 331.6,
    width: 0.48,
    height: 6.88,
    transform: "translate(-13.79 15.9) rotate(-2.42)",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.08,
    y: 334.8,
    width: 6.88,
    height: 0.48,
    transform: "translate(22.72 693.81) rotate(-87.54)",
    style: {
      fill: "#62CE71"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    transform: "matrix(1, 0, 0, 1, 52.682846, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.58,261.92a73.23,73.23,0,0,0,12,11.66c-4.73-14.34,2.72-42.74,2.74-38.45.09,20.5,7.67,44.61,12.11,46.69,0,0,0,0,.08,0,12.19,4.4,24.33,3.52,35,.3,0,0,0,0,0-.07-6.53-16.48.28-45.52.54-43.6,2.93,20.56,15.19,34.9,17.74,35.43h0c11.42-6.95,18.4-14.85,17.25-16.06-8.32-8.8-12.88-27.78-16.4-47.56h0c-3.5-19.5-3.51-37.32-10.44-55.57-6.36-16.7-24.85-23.67-37.3-18.59C89.19,149.46,83.57,255.85,88.58,261.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.07,135.38a19.44,19.44,0,0,0-7.42,3.78,46.28,46.28,0,0,0-6.12,5.76,79.11,79.11,0,0,0-9.4,13.9c-5.43,9.83-9,20.58-11.61,31.44A196.85,196.85,0,0,0,85,223.45c-.18,2.79-.2,5.58-.3,8.37l-.05,8.37.28,8.35.52,8.34,0-8.35.15-8.34.31-8.33c.19-2.77.29-5.55.55-8.31a215.26,215.26,0,0,1,4.9-32.87,133.29,133.29,0,0,1,11-31.22,81.65,81.65,0,0,1,8.85-14,45.63,45.63,0,0,1,5.75-6,28.62,28.62,0,0,1,3.36-2.42A13.83,13.83,0,0,1,124.07,135.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.82,255.16A142.75,142.75,0,0,1,182,241.93c-1.78-4.48-3.39-9-4.78-13.62s-2.64-9.24-3.6-13.93-1.76-9.48-2.64-14.22c-1.87-9.48-3.73-19-6.15-28.35-1.24-4.68-2.56-9.34-4.19-13.91a65.62,65.62,0,0,0-2.84-6.7,17.62,17.62,0,0,0-4.21-5.87,18.84,18.84,0,0,1,3.76,6.08,67.51,67.51,0,0,1,2.43,6.78c1.44,4.59,2.6,9.27,3.66,14,2.12,9.4,4,18.86,5.71,28.35.94,4.74,1.79,9.47,2.82,14.23a125.41,125.41,0,0,0,3.89,14A138.71,138.71,0,0,0,187.82,255.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.85,448.53H131.61q-1-3.91-2-7.84-.65-2.58-1.31-5.15c0-.11-.05-.21-.08-.32l-1.71-6.72c-.06-.22-.12-.44-.17-.66-.43-1.71-.87-3.42-1.29-5.11q-1.64-6.37-3.22-12.61c-.4-1.58-.8-3.17-1.21-4.73a1.42,1.42,0,0,0-.05-.22c-.25-1-.51-2-.76-3-1.63-6.38-3.2-12.57-4.7-18.49-.18-.7-.36-1.37-.54-2.05-1.32-5.21-2.58-10.17-3.77-14.83l-.5-2c-.29-1.15-.57-2.27-.86-3.37h0q-.39-1.5-.75-2.94c-.72-2.83-1.41-5.49-2-8-.1-.41-.21-.8-.3-1.19-.9-3.49-1.69-6.62-2.38-9.32-.13-.48-.24-.94-.36-1.39-.25-1-.49-1.92-.7-2.77-.11-.43-.21-.84-.32-1.23l-1.47-5.77H175.7S193.49,390.14,209.85,448.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,448.53H141.8q-2-7.87-3.92-15.74l-1.5-6Q134.7,420,133,413.17c0-.2-.09-.41-.14-.61-5.36-21.71-10.62-43.47-15.38-65.32-.06-.26-.12-.52-.17-.78a.11.11,0,1,1,.22,0l.07.26c6,21.41,11.61,43,17,64.58.11.37.2.75.29,1.12.45,1.78.89,3.54,1.34,5.31.62,2.51,1.26,5,1.89,7.53Q141.1,436.87,144,448.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.28,328.86l-10.59,53-.48,2.37-.75,3.77a.06.06,0,0,1,0,0l-1.2,6-1.11,5.59,0,.25-.21,1-9.49,47.56H131.61q-1-3.91-2-7.84-.65-2.58-1.31-5.15c0-.11-.05-.21-.08-.32-.58-2.24-1.14-4.48-1.71-6.72-.06-.22-.12-.44-.17-.66-.43-1.71-.87-3.42-1.29-5.11q-1.64-6.37-3.22-12.61c-.4-1.58-.8-3.17-1.21-4.73a1.42,1.42,0,0,0-.05-.22c-.25-1-.51-2-.76-3-1.63-6.38-3.2-12.57-4.7-18.49l-.54-2.05c-1.32-5.21-2.58-10.17-3.77-14.83-.17-.67-.33-1.33-.5-2-.29-1.15-.57-2.27-.86-3.37h0q-.39-1.5-.75-2.94c-.72-2.83-1.41-5.49-2-8-.1-.41-.21-.8-.3-1.19-.9-3.49-1.69-6.62-2.38-9.32-.13-.48-.24-.94-.36-1.39-.25-1-.49-1.92-.7-2.77-.11-.43-.21-.84-.32-1.23l-1.47-5.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.29,328.83v0c0,.42-.31,4.84-1,11.59a331.8,331.8,0,0,1-7,42.19c-.82,3.39-1.72,6.74-2.7,10-.66,2.26-1.38,4.5-2.15,6.62l-.06.19-1.3.49a148.13,148.13,0,0,0-20.33,10.29s0,.15,0,.42c-.05,1.48-.26,6.79-.56,14.57-.1,2.32-.19,4.86-.3,7.58-.18,4.75-.39,10.07-.6,15.74H62.37c1-12.59,1.94-25.37,2.9-37.76,0,0-7-19.61-6.24-29.52,1.89-24,12.65-52.39,12.65-52.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.73,381.52l.09-6c.06-3.66.31-7.32.45-11,.32-8.29.69-16.61,1.39-24.88,0-.2.35-.2.36,0,.12,3.29.19,6.57.18,9.86s.1,6.58.09,9.86c0,6.52,0,13-.27,19.56-.09,2.51-1,7.12,2.62,7.4,2.88.22,4.55-2.81,5.06-5.22a56.34,56.34,0,0,0,.68-9.09q.19-5,.21-9.93c0-7.21.17-14.4.36-21.6,0-.21.33-.19.36,0a218.91,218.91,0,0,1,1.39,21.87c0,3.5,0,7-.15,10.51-.11,3.27-.05,6.76-1.06,9.91-.79,2.47-2.58,4.84-5.2,5.49a.9.9,0,0,0-.16,0,.25.25,0,0,1,.13.19c.11,1.15.3,2.3.33,3.46s0,2.31-.1,3.45a22.78,22.78,0,0,1-.42,3.49,13,13,0,0,1-.41,1.63c-.18.56-.48,1-.71,1.55a.21.21,0,0,1-.4-.07h0c0-.19,0-.38-.06-.56a.34.34,0,0,0,0-.1h0a8.59,8.59,0,0,1-.07-1c0-.56.06-1.12.1-1.68.09-1.12.24-2.25.39-3.36s.23-2.24.36-3.36.35-2.29.45-3.45a.21.21,0,0,1,.07-.11,5.13,5.13,0,0,1-5.35-2.42A8.85,8.85,0,0,1,147.73,381.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.38,412.93a62.73,62.73,0,0,1,7.41-4.88,71.94,71.94,0,0,1,8.45-4.38c5.7-2.47,11.58-4.16,17.46-6.11.17-.06.29.24.12.3-5.7,2.27-11.16,5.28-16.66,8-2.71,1.33-5.45,2.59-8.21,3.81s-5.52,2.64-8.35,3.68C132.38,413.4,132.21,413.07,132.38,412.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.91,363.26c4,0,15.85.15,22-5.61,2.6-2.44,4-6,5.13-9.25a87.31,87.31,0,0,0,3.12-11.23c0-.19.31-.12.32.05A43.36,43.36,0,0,1,116.83,350c-1,3.51-2.27,7.44-5.11,9.91s-7.06,3.51-10.89,4a50,50,0,0,1-12.93-.18A.22.22,0,0,1,87.91,363.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.92,362.71c-1.8.12-7.13.68-10.32-4.84-1.35-2.35-2.24-5.85-3-9.05-.87-3.62-1.59-7.32-2.25-11.1,0-.18-.15-.11-.14.06a95.6,95.6,0,0,0,1.69,12.67c.7,3.47,1.59,7.34,3.05,9.71a7.35,7.35,0,0,0,5.21,3.59,10.34,10.34,0,0,0,5.81-.61C184.08,363.09,184.05,362.7,183.92,362.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5,335.16c-.1.37-9.85,37.12-9.4,46s5.66,26.85,5.68,27-.93,15.89-2.34,40.34h-1.9l2.33-40.12c-.22-1.33-5.24-18.4-5.68-27.1-.48-9.22,9-45.12,9.45-46.64a1,1,0,0,1,1.86.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.93,222.39c38.43,33.87,74.13,71,77.1,90.17,4.12,26.5-12.12,34.05-19.43,34.2-19.92.42-57-79.89-69.94-110.57C124.11,206.41,140.49,215,148.93,222.39Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.25,328.83l-5.36-33.68s13.34-13.8,6.44-28.26c-3.48-7.33-27.17-43-39.82-52-11.87-8.42-25.94-1.43-31.21,7.68C92,245.56,79.37,272,71.68,328.86Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.09,290.8a109.22,109.22,0,0,0-16,2.95c-2.6.72-5.14,1.56-7.68,2.45-1.26.44-2.54.84-3.82,1.24a17.4,17.4,0,0,1-4.1.86.1.1,0,0,0,0,.19,29.22,29.22,0,0,0,4-.15,28.36,28.36,0,0,0,3.77-.79c2.64-.71,5.24-1.53,7.88-2.26,5.3-1.48,10.61-3,16-4.05C154.42,291.19,154.34,290.77,154.09,290.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51,295.31a119.52,119.52,0,0,0-13.38-.38c-2.24.07-4.45.27-6.67.53-1.06.13-2.12.27-3.18.43s-2.3.5-3.46.65c-.12,0-.12.21,0,.19,1.1-.11,2.22,0,3.33-.09l3.33-.15c2.23-.1,4.46-.18,6.68-.3,4.46-.24,8.89-.43,13.35-.51A.19.19,0,0,0,167.51,295.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,219.09C68.18,247.19,33,295.76,32.76,322.92c-.26,26.81,9.08,24.21,11.73,24,16.2-1.06,54.35-75.69,66-106.11C122,210.65,112.8,212.14,104,219.09Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,326c1.88-3.38,3.81-6.72,5.63-10.12l5.58-10.15c3.68-6.78,7.42-13.53,11-20.37S95.48,271.76,99,264.9q2.67-5.13,5.2-10.33c1.75-3.44,3.34-6.95,5-10.46a208.21,208.21,0,0,1-8.86,21.43c-3.28,7-6.85,13.87-10.43,20.72s-7.45,13.55-11.4,20.19S70.46,319.68,66,326Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.39,253.1a32.59,32.59,0,0,1,2.21-3.51c.4-.55.78-1.11,1.21-1.64s.83-1.1,1.31-1.63a10.37,10.37,0,0,1-1.76,3.81A11.49,11.49,0,0,1,105.39,253.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.82,273.31c-1.88-12.59-5.64-30.14-10.18-33.77-4.78-3.81-22.09-16.55-27.07-18.21s-27.18-9.83-31.22-7.44c-3.23,1.92.72,10.43,11.29,14.41,9.28,3.5,14.08,6.8,16.74,7.92s9.29,9.79,7.56,13.68c-1,2.29-7.61,5-11.75,3.21s-5.25-10-10-13.76-13.05-3.23-13.51-1,2.3,3.26,6.63,10.84c2.79,4.87,3.1,16.63,9.39,25,3.16,4.2,8.72,15.42,8.72,15.42Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.75,235.93a8.23,8.23,0,0,1-4.13-1.82,3.12,3.12,0,0,1-1-2.72,1.56,1.56,0,0,1,.39-1c.08-.06,0-.16-.08-.08a4.49,4.49,0,0,1-.38.51,2.56,2.56,0,0,0-.23.47,2.81,2.81,0,0,0-.16,1,3.37,3.37,0,0,0,.84,2.09,5.62,5.62,0,0,0,4.75,1.65C155.82,236.05,155.82,235.94,155.75,235.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.64,239.54c-4.08-6.25-14.45-17.48-24.65-21.27-6.89-2.57-30.4,9.19-29.66,13.7s4.77,4.48,10.74,3.7c2.17-.28,13.64-4.53,15.63-2.14,2.86,3.44,6.57,15.27,6.57,15.27Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.9,230.2c2.87-4.87,9.25-7.52,15.62-9.62a.08.08,0,0,1,0,.15c-1.62.54-12,5.43-15.6,9.54C150.93,230.32,150.87,230.24,150.9,230.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.64,239.54c-4.08-6.25-14.45-17.48-24.65-21.27-6.89-2.57-25.43,12.35-24.69,16.86s6.54,4.81,12.92,2.51c2.06-.74,9-5.7,10.94-3.31,2.86,3.44,9.83,12,9.83,12Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,241c-.66-1-.88-1.33-1.55-2.3s-1.36-1.94-2.09-2.85a8.9,8.9,0,0,0-2.15-2.22,4.56,4.56,0,0,0-2.84-.52c-2.22.23-4.21,1.66-6.08,2.76-2.09,1.23-6.44,3.23-9.78,2.91a6.54,6.54,0,0,1-2.65-.68,4.18,4.18,0,0,1-1.59-1.25c-1.48-2.44.3-5.27,2.13-7.28,3.42-3.74,8-6.47,12.51-8.73,1.1-.55,2.21-1.08,3.33-1.6a9.86,9.86,0,0,1,4-1.2c2.32-.05,6.15,2.27,7.34,3,.09.05.16-.1.07-.15-1.44-.88-5-3.74-8.75-3.51a11.72,11.72,0,0,0-3.89,1.36c-1.3.57-2.58,1.19-3.85,1.84a54.52,54.52,0,0,0-7.1,4.3,22.27,22.27,0,0,0-5.78,5.59,6.52,6.52,0,0,0-.34,6.69c1,1.69,3.23,2.08,4.24,2.19a11.21,11.21,0,0,0,2.95,0,48.26,48.26,0,0,0,6.41-2c2-.83,3.84-2.22,5.92-2.87a4,4,0,0,1,3,.16,10.31,10.31,0,0,1,2.28,2.05,31.3,31.3,0,0,1,3.84,4.45C184.93,241.58,185.24,241.44,185,241Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.67,245c-1.51-3-4.12-15.29-6.54-19.05s-13.43-16.73-18.5-16.11c-6.37.78.4,12.21,3.79,16.91s2.91,12.75,2.91,12.75Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.68,219c1.2,1.48,2.27,3.13,3.32,4.73a38.21,38.21,0,0,1,2.9,4.67,16.66,16.66,0,0,1,1.3,5.24c.09.89.13,1.77.15,2.66s-.07,2,0,2.93c0,.1-.16.12-.16,0a43,43,0,0,0-.75-5.28,22.41,22.41,0,0,0-1.65-5.25c-1.53-3.33-3.74-6.28-5.3-9.59C181.4,218.93,181.59,218.84,181.68,219Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.26,240.85c.44,3.06-.44,6.16-1.54,9a31.16,31.16,0,0,1-2,4.16,34.66,34.66,0,0,1-2.6,3.79,35,35,0,0,0-4.56,7.49,36.51,36.51,0,0,0-2.36,8.58,23.76,23.76,0,0,1,1-9.07,27.46,27.46,0,0,1,4.39-8.11,43.09,43.09,0,0,0,4.7-7.46C187.6,246.56,188.92,243.86,189.26,240.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.75,345.84c-12.44-1.68-20.57-22.48-34.77-59-2.5-6.42,30-45.89,34.42-40,5.57,7.42,20.57,48.73,22.14,60C229.65,329,219.27,347.8,204.75,345.84Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.47,307.2l40.09-38.95s11.39,33.52,10.32,47.57-6,30.06-22.88,30.94C192.34,347.42,177.47,307.2,177.47,307.2Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.44,334.16c-1.45-2.05-2.74-4.2-4-6.36s-2.42-4.37-3.55-6.6-2.17-4.52-3.09-6.85a42.66,42.66,0,0,1-2.33-7.15c1.06,2.27,2.18,4.49,3.31,6.71l3.37,6.66c1.09,2.24,2.2,4.47,3.24,6.73S189.5,331.83,190.44,334.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.11,314c1.94-2.14,4.08-4.12,6.14-6.13s4.16-4,6.28-6q6.33-5.91,12.77-11.72,1.77-1.59,3.55-3.15c1.28-1.11,2.7-2.06,4-3.18a.11.11,0,0,1,.14.16c-1,1-1.91,2.11-2.91,3.12s-2.1,2.07-3.17,3.09q-3.13,3-6.3,5.95c-4.23,3.94-8.47,7.87-12.82,11.68-2.46,2.15-4.87,4.39-7.45,6.39A.15.15,0,0,1,186.11,314Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.59,216c.29,2,8.74,16.1,19.94,15.42C141,231,136.6,218,136.6,218l5.63-17.76-21.47-16.41S114.48,215.13,114.59,216Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46,195.56a35.53,35.53,0,0,0,18.46,21.49l5.32-16.76-21.48-16.41S119.72,189.15,118.46,195.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,175.35c.64,30.5-17.56,34.33-24.14,34.46-6,.12-26.32-.24-30.11-30.52s10.2-40.22,23.84-41.21S166.91,144.84,167.54,175.35Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.39,172.9a20.42,20.42,0,0,1-2-.58,3.43,3.43,0,0,1-2-1,1.08,1.08,0,0,1,.1-1.32,2.7,2.7,0,0,1,2.69-.43,4,4,0,0,1,2.38,1.58A1.16,1.16,0,0,1,160.39,172.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.48,172a18.42,18.42,0,0,0,2.09-.29,3.36,3.36,0,0,0,2.08-.69,1.08,1.08,0,0,0,.1-1.32,2.67,2.67,0,0,0-2.6-.82,3.87,3.87,0,0,0-2.58,1.21A1.16,1.16,0,0,0,139.48,172Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.26,180c0-.08-.16.09-.17.18,0,2.07-.43,4.45-2.34,5-.06,0-.06.12,0,.12C143.07,185.11,143.56,182,143.26,180Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.52,177.72c-3.32-.43-3.93,6.26-.85,6.65S144.31,178.07,141.52,177.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.18,178c-.62.33-1.25.94-2,1s-1.38-.75-1.85-1.47c-.05-.07-.11,0-.12.07-.13,1.28.24,2.63,1.6,2.95s2.23-.77,2.67-2C140.6,178.19,140.43,177.82,140.18,178Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.81,180.19c0-.08.15.12.14.2-.27,2.06-.23,4.47,1.58,5.34.05,0,0,.13,0,.11C155.24,185.3,155.22,182.1,155.81,180.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.87,178.21c3.35.08,3,6.77-.15,6.71S155.06,178.15,157.87,178.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.24,178.74c.51.38,1,1.06,1.62,1.14s1.32-.61,1.83-1.27c.05-.07.1,0,.1.08,0,1.28-.55,2.59-1.79,2.76s-1.9-1-2.13-2.28C158.83,178.93,159,178.58,159.24,178.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.23,195.94c.43.55.83,1.28,1.57,1.44a5.51,5.51,0,0,0,2.28-.21c.07,0,.13.06.08.11a2.81,2.81,0,0,1-2.77.77A2.22,2.22,0,0,1,143,196C143,195.88,143.17,195.86,143.23,195.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.48,189.13s.19,3.12.07,4.58c0,.14-.37.18-.86.17h-.06a7,7,0,0,1-6.54-3.12c-.09-.15.11-.29.23-.19a10.5,10.5,0,0,0,6.2,2.31c.13-.39-.5-5.34-.26-5.34a12.56,12.56,0,0,1,3.25,1c-.19-6.53-1.44-13-1.53-19.47a.19.19,0,0,1,.38-.07c1.78,6.66,2.17,14.17,2.55,20.9C156,190.75,153.05,189.42,152.48,189.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,178.59c7.51,1,13.56-21.58,14.27-24.36-.35,1.78-2.21,11.18-1.56,11.68a7.19,7.19,0,0,0,2.42,0h0a22.88,22.88,0,0,1,.84-3.33c.15-.51,0,1.17,0,3.26.44,0,.92-.11,1.44-.15a27.67,27.67,0,0,1,1.93-7.06c.37-.85-.07,3.2.19,6.85,5.38-.52,13.13-1.08,20.12-.14,1.88.25,3.48.54,4.89.85.48-2.78.66-5.81.76-5.13a27.49,27.49,0,0,1,.29,5.37c.76.18,1.46.35,2.09.52.86-3.9.05-10.51.52-9.44a28.09,28.09,0,0,1,2.16,10.35c2.6,1,3.25,1.62,3.45.94.34-1.24.67-12.52-6.55-22.06-7.84-10.36-26.08-15.72-38.86-4,0,0-9.6,4.18-12.5,13S109.65,178,114,178.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.47,179.45s-6-9.94-10.49-7.85-.38,16.19,4.56,18.41a5.16,5.16,0,0,0,7.08-2.32Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.25,175.61a.07.07,0,0,0,0,.13c3.46,1.68,5.11,5.09,6.2,8.59-1-1.38-2.36-2.2-4.2-1.06-.1.06,0,.21.08.2a3.17,3.17,0,0,1,3.41,1.33,15.83,15.83,0,0,1,1.49,2.93c.14.33.73.2.63-.17a.29.29,0,0,1,0-.09C117.18,183,114.08,176.39,109.25,175.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.92,230.33,128,282.65c-.67,1.52,0,2.84,1.57,2.94l27.45,1.8a4.46,4.46,0,0,0,4-2.58l16.89-52.32c.67-1.53,0-2.85-1.56-3l-27.45-1.8A4.45,4.45,0,0,0,144.92,230.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.18,230.51l-16.89,52.32c-.67,1.53,0,2.85,1.57,2.95l27.45,1.8a4.46,4.46,0,0,0,4-2.58l16.89-52.33c.67-1.52,0-2.84-1.56-2.94l-27.45-1.8A4.44,4.44,0,0,0,148.18,230.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.55,233.43a2.34,2.34,0,1,1-2.13-2.53A2.34,2.34,0,0,1,155.55,233.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.77,346.9c12,1.65,26.93-7.66,65.68-35.95,5.36-3.91-12.09-49.18-18-45.3-7.48,4.9-35.46,25.51-37.31,27.28C35.46,307.82,32.64,345.78,40.77,346.9Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.58,279.34s11-15.48,19.35-21.82c11.14-8.49,24.25-11.24,29.81-12.06,11.61-1.71,40.87,2.19,41.22,10.81.32,7.81-29.39,2.32-29.39,2.32s31.21.6,29.87,10.07S130,269.79,130,269.79s32.06,1.33,29.13,10.88c-2.22,7.21-33.55,1.4-33.55,1.4s27.54,1.34,25.58,8.86c-2.17,8.3-31.42,4.75-31.42,4.75-8.2,18.27-20,23.41-28.51,26.25C89.12,322.62,74.58,279.34,74.58,279.34Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.79,257.69c3.67-.07,7.38-.15,11,.11s7.32.66,10.94,1.26a63.07,63.07,0,0,1,13.87,3.69c-8.16-2.53-21.25-3.68-24.91-3.95s-7.3-.71-11-1C124.68,257.82,124.7,257.69,124.79,257.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.59,270.89c4.69.13,9.35.08,14,.41s9.05,1.05,13.68,1.7c.35.05.21.22-.15.18-4.65-.46-9-.53-13.64-.94s-9.29-1-13.94-1.24C123.51,271,123.52,270.89,123.59,270.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.53,282c7.18-.18,14.37,1,21.41,2.26.35.07.14.27-.22.23-7.11-.89-12.67-1.63-21.18-2.24C120.4,282.28,120.38,282,120.53,282Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.58,273.19l15.27,55.64s-41,24.11-50,17.74S36.71,308.06,47,295.81C51.22,290.7,74.58,273.19,74.58,273.19Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.09,275l-.6-1.83.15.06c-3.87,3.16-7.75,6.29-11.58,9.48s-7.67,6.37-11.31,9.74a57.11,57.11,0,0,0-5.2,5.24,43,43,0,0,0-4.13,6.1,46.94,46.94,0,0,0-4.94,14,39.39,39.39,0,0,1,4-14.46,35.77,35.77,0,0,1,4.08-6.4,57.8,57.8,0,0,1,5.25-5.47c3.71-3.37,7.6-6.53,11.54-9.6s8-6,12.18-8.75l.12-.08,0,.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.61,287c.93,2.73,1.64,5.55,2.41,8.33s1.52,5.58,2.23,8.39c1.42,5.6,2.81,11.21,4.12,16.84.36,1.54.72,3.08,1,4.63s.51,3.35.88,5a.1.1,0,0,1-.2.05c-.37-1.37-.94-2.69-1.34-4.06s-.81-2.83-1.18-4.26q-1.11-4.19-2.18-8.39c-1.43-5.6-2.83-11.21-4.07-16.86-.7-3.18-1.5-6.38-2-9.6A.15.15,0,0,1,65.61,287Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.85,328.83c.27.52.25.08.19-.24s-.69-3-1.28-4.7c-.06-.17-.32-.47-.22.14A46.74,46.74,0,0,0,89.85,328.83Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInGirl);
export default __webpack_public_path__ + "static/media/sign_in_girl.4a2e6dd1269d4d940e1be40a09081848.svg";
export { ForwardRef as ReactComponent };